module.exports = __webpack_public_path__ + "static/media/10.e1254740.jpg";